import apiClient, { type PagedResponse } from '../../client'
import type {
  MeasurementUnitItem,
  CreateMeasurementUnitRequest,
  UpdateMeasurementUnitRequest,
  GetMeasurementUnitsParams,
  ConvertMeasurementRequest,
  ConvertMeasurementResponse,
} from '../../models/maestros.models'

const BASE_PATH = '/maestros/measurement-units'

export const measurementUnitsCatalogService = {
  async getAll(params?: GetMeasurementUnitsParams): Promise<PagedResponse<MeasurementUnitItem>> {
    return apiClient.get<PagedResponse<MeasurementUnitItem>>(BASE_PATH, params)
  },
  async getById(id: string): Promise<MeasurementUnitItem> {
    return apiClient.get<MeasurementUnitItem>(`${BASE_PATH}/${id}`)
  },
  async create(data: CreateMeasurementUnitRequest): Promise<MeasurementUnitItem> {
    return apiClient.post<MeasurementUnitItem, CreateMeasurementUnitRequest>(BASE_PATH, data)
  },
  async update(id: string, data: UpdateMeasurementUnitRequest): Promise<MeasurementUnitItem> {
    return apiClient.put<MeasurementUnitItem, UpdateMeasurementUnitRequest>(`${BASE_PATH}/${id}`, data)
  },
  async delete(id: string): Promise<void> {
    return apiClient.delete<void>(`${BASE_PATH}/${id}`)
  },
  async convert(data: ConvertMeasurementRequest): Promise<ConvertMeasurementResponse> {
    return apiClient.post<ConvertMeasurementResponse, ConvertMeasurementRequest>(
      `${BASE_PATH}/convert`,
      data,
    )
  },
}
